import { ContentfulProductWithShopifyData } from "@lib/types"
import { FC } from "react"
import styled from "styled-components"

import { ProductListing } from "./ProductListing"

interface Props {
  data: {
    productsCollection: {
      items: ContentfulProductWithShopifyData[]
    }
  }
}

export const ProductsRow: FC<Props> = ({ data }) => {
  const { productsCollection } = data

  return (
    <StyledProductsRow>
      <ProductListing products={productsCollection.items} repeat={4} />
    </StyledProductsRow>
  )
}

const StyledProductsRow = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoint.md}px) {
    margin: 0 0 3rem;
  }
`
